import { render, staticRenderFns } from "./v-navbar-menu.vue?vue&type=template&id=8157e71c&scoped=true&"
var script = {}
import style0 from "./v-navbar-menu.vue?vue&type=style&index=0&id=8157e71c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8157e71c",
  null
  
)

export default component.exports